import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { both } from '@infl-ts/util-io-ts';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import { parse, stringify } from 'qs';
import { useChallengePlayer } from '../use-challenge-player';
export var createChallengePlayerLink = function createChallengePlayerLink(pathname, challengeConfig, otherSearchParams) {
  return "".concat(pathname, "?").concat(stringify(_objectSpread(_objectSpread({}, otherSearchParams), {}, {
    cp: _objectSpread({}, challengeConfig)
  })));
};
var ExpectedChallengeParams = both({
  uuid: t.string
}, {
  minimized: t.string,
  activity: t.union([t.literal('new'), t.string])
});
export var parseChallengePlayerConfig = function parseChallengePlayerConfig(location) {
  return pipe(location.search, function (searchParams) {
    return parse(searchParams, {
      ignoreQueryPrefix: true
    });
  }, function (parsedParams) {
    return parsedParams['cp'];
  }, function (challengePlayerParams) {
    return ExpectedChallengeParams.is(challengePlayerParams) ? O.some(_objectSpread(_objectSpread({
      uuid: challengePlayerParams.uuid
    }, challengePlayerParams.minimized ? {
      minimized: challengePlayerParams.minimized === 'true'
    } : {}), challengePlayerParams.activity ? {
      activity: challengePlayerParams.activity
    } : {})) : O.none;
  });
};
export var removeCPSearchParams = function removeCPSearchParams(history, search) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return pipe(parse(search, {
    ignoreQueryPrefix: true
  }), function (parsedParams) {
    return parsedParams['cp'] ? _objectSpread(_objectSpread({}, parsedParams), {}, {
      cp: undefined
    }) : parsedParams;
  }, function (newSearchParams) {
    var method = replace ? history.replace.bind(history) : history.push.bind(history);
    method({
      search: stringify(newSearchParams)
    });
  });
};
export var removeCPSearchParam = function removeCPSearchParam(param) {
  if (false) return;
  var newUrl = new URL(window.location.href);
  newUrl.searchParams["delete"]("cp[".concat(param, "]"));
  window.history.replaceState(null, '', newUrl.toString());
};
export var useMinimizeChallengePlayer = function useMinimizeChallengePlayer(pathname) {
  var _useChallengePlayer = useChallengePlayer(),
      challengeConfig = _useChallengePlayer.challengePlayerState.challengeConfig;

  return challengeConfig ? createChallengePlayerLink(pathname, _objectSpread(_objectSpread({}, challengeConfig), {}, {
    minimized: true
  })) : '';
};
export var addActivityIdToUrl = function addActivityIdToUrl(activityId) {
  if (false) return;
  var newUrl = new URL(window.location.href);
  newUrl.searchParams.set('cp[activity]', activityId);
  window.history.replaceState(null, '', newUrl.toString());
};